import React from 'react';
import CardButton from '../CardButton/CardButton';
import './TutorDaySlide.css';
import { cosmosTrackService } from '../../../../../cosmosTracking/cosmosTrackService';
import {tutor_of_the_day, View_checklist} from '../../../../../cosmosTracking/cosmosEvents';
import { SOURCE_HOME, directDeepLink } from '../../../util';
import holippl from '../../../../../assets/images/holi-people.png';
import { resolveTutorHomeAsset } from '../tutorHomeConfig';
function TutorDaySlide(props) {
	const { data, rewardText, config = {} } = props;
	return (
		<div className="slideCard slideCardTutor">
			<div className="cardBody" style={config.images?.card_background ? {'--tutor-home-card-background': `url("${resolveTutorHomeAsset(config.images.card_background)}")`} : undefined}>
				{/* <img src={holippl} className='overlay-image' /> */}

				<div className="body-card-inner">
				<img className="tutor-top-img" src={resolveTutorHomeAsset(config.images?.header_artwork)} alt="tutor of day"/>
				</div>
				
				<div className="tutorData" onClick={() => {cosmosTrackService(tutor_of_the_day);directDeepLink(data?.deeplink, SOURCE_HOME);}}
					 deeplink={data?.deeplink}>
					<img src={data?.orgLogo} width={60} alt="tutor" height={60} />
					<h4>{data?.orgName}</h4>
				</div>
				<CardButton text={config.text?.cta_label || 'Be the one '} className={'btn-action'} eventCallback={() => {cosmosTrackService(tutor_of_the_day);}} deeplink={data?.deeplink}
				/>
			</div>
		</div>
	);
}

export default TutorDaySlide;
